export default "__VITE_ASSET__DWGtyKrG__"